import { SignatureOutlined, FormOutlined } from '@ant-design/icons';
import {
  ActiveLog,
  DashboardNew,
  Settings,
  RealTimeChatNew,
  TelephonePlus,
  ChatRecordsNew,
  ReportsNew,
  Briefcase,
  Teams,
  AgentNew,
  ReportDashboard,
  Schedule,
  DocumentVerification
} from '../assets/icons/jsxIcons/index';

export const unifiedSidebarData = [
  {
    title: 'Dashboard',
    route: '',
    Icon: DashboardNew,
    index: 1,
    roles: ['super-admin', 'admin', 'user'] // Available to all roles
  },
  {
    title: 'Conversations',
    route: 'CONVERSATIONS',
    Icon: RealTimeChatNew,
    index: 2,
    roles: ['super-admin', 'admin', 'user'] // Available to all roles
  },
  {
    title: 'Call Requests',
    route: 'CALL-REQUESTS',
    Icon: TelephonePlus,
    index: 3,
    roles: ['super-admin', 'admin', 'user'] // Available to all roles
  },
  {
    title: 'Documents',
    route: 'DOCUMENTS',
    Icon: DocumentVerification,
    badge: 'New',
    roles: ['super-admin', 'admin'], // Not available to regular users
    children: [
      {
        title: 'eSign',
        route: 'esignature',
        Icon: SignatureOutlined,
        badge: '',
        roles: ['super-admin', 'admin']
      },
      {
        title: 'Forms',
        route: 'esignature/templates',
        Icon: FormOutlined,
        badge: '',
        roles: ['super-admin'] // Only super-admin
      },
      {
        title: 'Verify',
        route: 'VERIFICATION',
        Icon: DocumentVerification,
        badge: '',
        roles: ['super-admin', 'admin']
      }
    ]
  },
  {
    title: 'Records',
    route: 'RECORDS',
    Icon: ChatRecordsNew,
    index: 4,
    roles: ['super-admin', 'admin', 'user'] // Available to all roles
  },
  {
    title: 'Reports',
    route: 'REPORTS',
    Icon: ReportsNew,
    index: 5,
    roles: ['super-admin', 'admin'], // Not available to regular users
    children: [
      {
        title: 'Analytics',
        route: 'REPORTS',
        Icon: ReportDashboard,
        roles: ['super-admin', 'admin']
      },
      {
        title: 'Scheduler',
        route: 'SCHEDULER',
        Icon: Schedule,
        roles: ['super-admin', 'admin']
      },
      {
        title: 'Logs',
        route: 'LOGS',
        Icon: ActiveLog,
        index: 8,
        roles: ['super-admin', 'admin']
      }
    ]
  },
  {
    title: 'Departments',
    route: 'departments',
    Icon: Briefcase,
    roles: ['super-admin', 'admin'], // Not available to regular users
    children: [
      {
        title: 'Teams',
        route: 'teams',
        Icon: Teams,
        roles: ['super-admin', 'admin']
      },
      {
        title: 'Agents',
        route: 'agents',
        Icon: AgentNew,
        roles: ['super-admin', 'admin']
      }
    ]
  },
  {
    title: 'Settings',
    route: 'SETTINGS',
    Icon: Settings,
    roles: ['super-admin'] // Only super-admin
  }
];
